module.exports = __webpack_public_path__ + "img/sc.1bcfd2c7.svg";